export const TimeHorizon = [
  { id: 'Longest', name: 'Longest (8 years or more)', code: 'longest' },
  { id: 'Average', name: 'Average (4 to 7 years)', code: 'average' },
  { id: 'Short', name: 'Short (less than 3 years)', code: 'short' }
];
